import { applyMiddleware, combineReducers, createStore, compose } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'
// middleware imports
import DtmfMiddleware from 'middleware/Dtmf.middleware'
import GlobalEventMiddleware from 'middleware/GlobalEvents.middleware'
import GtagMiddleware from 'middleware/Gtag.middleware'
import SearchMiddleware from 'middleware/Search.middleware'

// reducer imports
import analyticsReducer from 'redux/Anaytics/reducer'
import authReducer from 'redux/Auth/reducer'
import configReducer from 'redux/Config/reducer'
import contactsReducer from 'redux/Contacts/reducer'
import notificationsReducer from 'redux/Notifications/reducer'
import sessionsReducer from 'redux/Sessions/reducer'
import sipReducer from 'redux/Sip/reducer'

// choose enhancer
let composeEnhancers = compose
if (
  process.env.REACT_APP_LOCAL ||
  !window.location.hostname.startsWith('app')
) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
}

// create middleware list
const middleware = [
  thunk,
  promise,
  DtmfMiddleware,
  GlobalEventMiddleware,
  SearchMiddleware,
]

if (GtagMiddleware) {
  middleware.push(GtagMiddleware)
}

const middlewares = applyMiddleware(...middleware)
const enhancers = composeEnhancers(middlewares)

const reducers = combineReducers({
  analytics: analyticsReducer,
  auth: authReducer,
  config: configReducer,
  contacts: contactsReducer,
  notifications: notificationsReducer,
  sessions: sessionsReducer,
  sip: sipReducer,
})

const store = createStore(reducers, {}, enhancers)

export default store
